import VesselApi from '@/api/vsl/vessel.api';

const initialState = () => ({
  vesselList: [],
});

const state = initialState();
const getters = {};
const mutations = {
  RESET(state, payload) {
    const initStates = initialState();
    if (!payload) {
      Object.keys(initStates).map((key) => {
        state[key] = initStates[key];
      });
    } else {
      const statesToReset = payload;
      statesToReset.map((key) => {
        state[key] = initStates[key];
      });
    }
  },
  SET_VESSEL_LIST(state, payload) {
    state.vesselList = payload;
  },
};
const actions = {
  async fetchVesselList({ commit }, payload) {
    const res = await VesselApi.fetchVesselList();
    const mapped = res.data.data.map(({ code, name }) => ({
      code,
      //   name: `${code} - ${name}`,
      name,
    }));
    commit('SET_VESSEL_LIST', mapped);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
